'use strict';

var _ = require('lodash');
var ReviewInputDataChartServiceProvider = function ReviewInputDataChartServiceProvider($filter, $q, retrieverConstants, dataRetrieverService, seasonalityConstants, svgPatternService, momentService, seasonalityCommonService) {
  var NUMBER_OF_WEEKS_IN_YEAR_RANGE = 52;
  var NUMBER_OF_DAYS_IN_WEEK = 7;
  var rmMomentFormat = $filter('rmMomentFormat');
  var WEEK_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  var WEEK_DAYS_REVERSE = _.clone(WEEK_DAYS).reverse();
  var CSS_CLASSES = _.map(WEEK_DAYS, function (d) {
    return 'rm-review-input-data-color-' + d;
  });
  var CSS_CLASSES_REVERSE = _.clone(CSS_CLASSES).reverse();
  function retrieveData(market, spos, classGroup, dateFromMoment, dateToMoment) {
    var m = market.split('-');
    var rqlQuery = '' + 'origin==' + m[0] + ';destination==' + m[1] + (spos !== undefined ? ';significantPOS=="' + spos + '"' : '') + (classGroup !== undefined ? ';classGroup=="' + classGroup + '"' : '') + ';departureDate=ge="' + dateFromMoment.toISOString() + '"' + ';departureDate=le="' + dateToMoment.toISOString() + '"';
    return dataRetrieverService.getDataRetriever(retrieverConstants.SEASONALITY_SCREEN, retrieverConstants.SEASONALITY_UNTRUNCATED_MD_MODE).setCustomSearchCriteriaRules($q.when(rqlQuery)).localSortApplied().retrieveComponentData(retrieverConstants.REVIEW_INPUT_DATA_CHART);
  }
  function getLegend() {
    var legend = [];
    var allWeek = {
      label: 'All',
      id: 'all',
      styleClass: 'legend-item-all',
      selectable: true,
      selected: true
    };
    var exclusion = {
      label: 'Exclusion',
      id: 'exclusion',
      separatorLeft: true,
      fill: svgPatternService.getPatternUrl('user-exclusion')
    };
    var noData = {
      label: 'No Data',
      id: 'nodata',
      separatorLeft: true,
      fill: svgPatternService.getPatternUrl('gap-pattern')
    };
    var dowItems = _.map(WEEK_DAYS, function (item) {
      return {
        label: item,
        id: item,
        styleClass: 'legend-item-' + item,
        selectable: true,
        selected: false
      };
    });
    return legend.concat(dowItems, allWeek, noData, exclusion);
  }
  function calculateStripeHeight(inputData, index, groupByWeeks, selectedDays, allWeek) {
    inputData.weekNumber = index;
    inputData.d1 = groupByWeeks ? inputData.weekNumber : inputData.monthNameDateLabel;
    inputData['all-week'] = 0;
    inputData.data = inputData.data === undefined ? undefined : _.chain(inputData.data).reverse().map(function (dowValue, i) {
      if (allWeek) {
        inputData['all-week'] = inputData['all-week'] + (dowValue || 0);
      }
      if (_.includes(selectedDays, WEEK_DAYS_REVERSE[i])) {
        return dowValue || 0;
      } else {
        return 0;
      }
    }).forEachRight(function (dowValue, i, collection) {
      if (i !== collection.length - 1) {
        var tempArray = collection.slice(i + 1);
        var previous = _.find(tempArray, function (val) {
          return val !== 0;
        });
        if (dowValue !== 0 && previous) {
          collection[i] = collection[i] + previous;
        }
      }
    }).value();
  }
  function selectedDaysToDayShift(selectedDays) {
    var firstSelectedDay = _.first(selectedDays);
    return firstSelectedDay ? WEEK_DAYS.indexOf(firstSelectedDay) : 0;
  }
  function transformData(data, selectedMetric, fromMoment, toMoment, selectedDays, allWeek, displayMode, exclusionDates) {
    var groupByWeeks = displayMode === seasonalityConstants.DISPLAY_BY_WEEK_MODE;
    var dayShift = allWeek ? 0 : selectedDaysToDayShift(selectedDays);
    if (data.results === undefined) {
      return {
        data: undefined
      };
    }
    if (data.results.length === 0) {
      return {
        data: []
      };
    }

    //process the data
    var result = [];
    data.results = _.sortBy(data.results, 'weekNumber');
    _.forEach(data.results, function (d) {
      var realWeekNumber = seasonalityCommonService.seasonalityWeekOfYear(d.weekStartDate, momentService.FIELD.WEEK_START_DATE);
      if (result[realWeekNumber - 1]) {
        var oldData = result[realWeekNumber - 1].data;
        var newData = _.map(d.reservationHoldings, selectedMetric);
        result[realWeekNumber - 1].data = mergeSameWeekNumberData(oldData, newData);
      } else {
        result[realWeekNumber - 1] = {
          isGap: false,
          css: CSS_CLASSES_REVERSE,
          weekNumber: realWeekNumber,
          data: _.map(d.reservationHoldings, selectedMetric)
        };
      }
    });
    addGaps(result, toMoment, dayShift);
    result.forEach(function (d, i) {
      calculateStripeHeight(d, i + 1, groupByWeeks, selectedDays, allWeek);
      addExclusions(d, exclusionDates, selectedDays, allWeek);
    });
    return {
      data: result
    };
  }
  function mergeSameWeekNumberData(oldData, newData) {
    var finalData = [];
    for (var idx = 0; idx < 7; idx++) {
      if (oldData[idx]) {
        finalData[idx] = oldData[idx];
      } else {
        finalData[idx] = newData[idx];
      }
    }
    return finalData;
  }
  function isDateInWeek(dateMoment, weekStartDateMoment) {
    var firstDayOfWeek = weekStartDateMoment.startOf('isoWeek');
    return dateMoment.isAfter(firstDayOfWeek.subtract(1, 'days'), 'day') && dateMoment.isBefore(firstDayOfWeek.add(NUMBER_OF_DAYS_IN_WEEK, 'days'), 'day');
  }
  function addExclusions(d, exclusionDates, selectedDays, allWeek) {
    if (d.data === undefined) {
      return;
    }
    var exclusionPattern = svgPatternService.getPatternUrl('user-exclusion');
    addExclusionPatternToWeek(d, exclusionDates, selectedDays, allWeek, exclusionPattern);
    addExclusionPatternToDays(d, exclusionDates, selectedDays, exclusionPattern);
  }
  function addExclusionPatternToWeek(d, exclusionDates, selectedDays, allWeek, exclusionPattern) {
    if (allWeek && selectedDays.length === 0) {
      _.forEach(exclusionDates, function (dateMoment) {
        if (isDateInWeek(dateMoment, d.weekStartDateMoment)) {
          d.fill = exclusionPattern;
        }
      });
    }
  }
  function addExclusionPatternToDays(d, exclusionDates, selectedDays, exclusionPattern) {
    var isPatternApplied = false;
    var css = _.clone(CSS_CLASSES);
    var data = _.clone(d.data).reverse();
    var patternCount = 0;
    var userExclusionFillArray = _.times(NUMBER_OF_DAYS_IN_WEEK, _.noop);
    _.forEach(exclusionDates, function (dateMoment) {
      if (isDateInWeek(dateMoment, d.weekStartDateMoment)) {
        var day = _.toLower(rmMomentFormat(dateMoment, 'DAY_OF_WEEK'));
        if (_.includes(selectedDays, day)) {
          var i = _.indexOf(WEEK_DAYS, day);
          css.splice(i + patternCount, 0, '');
          data.splice(i + patternCount, 0, data[i + patternCount]);
          userExclusionFillArray.splice(i + patternCount, 0, exclusionPattern);
          patternCount++;
          isPatternApplied = true;
        }
      }
    });
    if (isPatternApplied) {
      d.css = css.reverse();
      d.data = data.reverse();
      d.fill = userExclusionFillArray.reverse();
    }
  }
  function addGaps(result, toMoment, dayShift) {
    var start = seasonalityCommonService.getFirstMonday(toMoment.year());
    if (start.isAfter(toMoment)) {
      start.subtract(NUMBER_OF_WEEKS_IN_YEAR_RANGE, 'weeks');
    }
    _.range(0, NUMBER_OF_WEEKS_IN_YEAR_RANGE).forEach(function (weekNumber) {
      var date = start.add(weekNumber, 'weeks');
      if (date.isAfter(toMoment)) {
        date = date.subtract(NUMBER_OF_WEEKS_IN_YEAR_RANGE, 'weeks');
      }
      date = date.add(dayShift, 'days');
      if (date.isAfter(toMoment)) {
        date = date.subtract(NUMBER_OF_WEEKS_IN_YEAR_RANGE, 'weeks');
      }
      if (!result[weekNumber]) {
        result[weekNumber] = {
          isGap: true,
          stackLabel: rmMomentFormat(date, 'DATE_ISO'),
          weekStartDateMoment: date,
          monthNameDateLabel: rmMomentFormat(date, 'DATE_USER_SETTINGS')
        };
      } else {
        result[weekNumber].stackLabel = rmMomentFormat(date, 'DATE_ISO');
        result[weekNumber].weekStartDateMoment = date;
        result[weekNumber].monthNameDateLabel = rmMomentFormat(date, 'DATE_USER_SETTINGS');
      }
    });
  }
  function getData(market, spos, classGroup, dateFromMoment, dateToMoment, selectedMetric, selectedDays, allWeek, displayMode, exclusionDates) {
    return retrieveData(market, spos, classGroup, dateFromMoment, dateToMoment).then(function (data) {
      var dowSelection = _.clone(selectedDays).reverse();
      return transformData(data, selectedMetric, dateFromMoment, dateToMoment, dowSelection, allWeek, displayMode, exclusionDates);
    });
  }
  return {
    getData: getData,
    getLegend: getLegend
  };
};
ReviewInputDataChartServiceProvider.$inject = ['$filter', '$q', 'DataRetrieverConstantsService', 'DataRetrieverService', 'SeasonalityConstants', 'SvgPatternService', 'MomentService', 'SeasonalityCommonService'];
module.exports = ReviewInputDataChartServiceProvider;